<template>
  <v-container fluid>
    <v-navigation-drawer v-model="drawer" app dark class="sidebar-dark">
      <v-img width="100px" height="100px" class="rounded-circle mx-auto my-8 my-lg-4"
        :src="user.avatar !== null ? `https://api.mylegis.com.br/assets/${user.avatar}` : require('../assets/icon-person.svg')" />

      <h3 class="px-4 text-center white--text">
        {{user.first_name}}
      </h3>
      <v-list nav class="sidebar-menu">
        <v-list-item v-for="(item,x) in itemsMenu" :key="x" :to="{ name: item.route }" exact :exact-active-class="'v-list-item--active'" :active-class="'v-list-item--active'" class="menu-item mb-0">
          <v-list-item-action class="mr-3">
            <v-icon color="white">{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="white--text">{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="logout()" key="logout" class="menu-item">
          <v-list-item-content>
            <span class="white--text">Sair</span>
          </v-list-item-content>
          <v-list-item-action>
            <v-icon color="white">mdi-logout</v-icon>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-main>
      <v-container fluid>
        <v-row class="px-0" :class="intBreakPoint >= 2 ? `py-5 ` : ``">
          <v-col class="mt-0 pt-0 d-flex justify-space-between" v-if="intBreakPoint >= 2" cols="4">
            <div class="d-flex align-center">
              <v-icon color="#F15A24" class="mr-2" size="30">{{label.icon}}</v-icon>
              <h2 class="orange--text">{{label.title}}</h2>
            </div>
          </v-col>
          <v-col class="mt-0 pt-0 d-flex" v-if="intBreakPoint >= 2" cols="4">
            <div class="d-flex align-center">
              <v-carousel height="60" v-model="showBannerDestaque"  class="px-5" cycle :interval="10000" hide-delimiters :show-arrows="false">
                <small style="font-size:10px !important;">Patrocínio</small>
                <v-carousel-item v-for="b in banners" :key="b.directus_files_id">
                  <a :href="b.link" target="_blank">
                  <v-img :src="`https://api.mylegis.com.br/assets/${b.directus_files_id}`" class="mx-auto mb-10" width="300" contain height="45" />
                  </a>
                </v-carousel-item>
            </v-carousel> 
            </div>
          </v-col>

          <v-col class="mt-0 pt-0 d-flex justify-end align-center" v-if="intBreakPoint >= 2" cols="4">
            <div class="d-flex align-center" style="gap: 16px;">
              <!-- Botão de Amigos com Notificações -->
              <v-btn
                text
                @click="abrirAmigos"
                class="px-2"
                style="position: relative; min-width: auto;"
              >
                <v-badge
                  v-if="pendingNotificationsCount > 0"
                  :content="pendingNotificationsCount"
                  color="#F15A24"
                  overlap
                  :offset-x="10"
                  :offset-y="10"
                >
                  <v-icon color="#F15A24" size="28">mdi-account</v-icon>
                </v-badge>
                <v-icon v-else color="#F15A24" size="28">mdi-account</v-icon>
                <span class="ml-2" style="color: #141414; font-weight: 500; font-size: 15px;">Amigos</span>
              </v-btn>
              <v-img src="../assets/logo.png" contain width="120px" height="50" />
            </div>
          </v-col>
          <v-col class="d-flex justify-start align-center" v-if="intBreakPoint <= 2" cols="12">
            <div class="d-flex align-center" style="gap: 12px; width: 100%;">
              <v-app-bar-nav-icon class="justify-start" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
              <!-- Botão de Amigos com Notificações (Mobile) -->
              <v-btn
                text
                @click="abrirAmigos"
                class="px-2"
                style="position: relative; min-width: auto;"
              >
                <v-badge
                  v-if="pendingNotificationsCount > 0"
                  :content="pendingNotificationsCount"
                  color="#F15A24"
                  overlap
                  :offset-x="10"
                  :offset-y="10"
                >
                  <v-icon color="#F15A24" size="24">mdi-account</v-icon>
                </v-badge>
                <v-icon v-else color="#F15A24" size="24">mdi-account</v-icon>
              </v-btn>
              <v-spacer></v-spacer>
              <v-img src="../assets/logo.png" contain width="100px" height="40" />
            </div>
          </v-col>

          <v-col class="mt-0 pt-0  justify-center d-flex" v-if="intBreakPoint < 2" cols="12" lg="6">
            <div class="d-flex align-center">
				<v-icon color="#F15A24" class="mr-2" size="30">{{label.icon}}</v-icon>
				<h2 class="orange--text">{{label.title}}</h2>
            </div>
          </v-col>
        </v-row>

        <!-- Barra de pesquisa -->

        <router-view></router-view>
        
        <!-- Modal de confirmação para excluir amizade -->


        <!-- Botão Como usar -->
        <v-btn fab small class="fixed-bottom-left" style=" background-color: #fda16bbe;" @click="showFaq = true">
          <v-icon color="white">mdi-help</v-icon>
        </v-btn>
        <span class="fixed-bottom-left-text">Como usar?</span>
        
        <!-- Dialog FAQ -->
        <DialogFaq :showFaq="showFaq" @update:showFaq="showFaq = $event" />
        
        <!-- Dialog Integrantes Gabinete -->
        <DialogIntegrantesGabinete 
          v-model="showDialogGabinete" 
        />
        
        <!-- Dialog de Feedback CSAT (exibido após 3 logins, apenas uma vez) -->
        <CSATRating 
          page-name="Experiência Geral"
          :pergunta-id="1"
          :delay-seconds="3"
          :auto-show="true"
          @rating-submitted="handleRatingSubmitted"
        />
      </v-container>
    </v-main>
  </v-container>
</template>
<style scoped>

.fixed-bottom-left:hover{
	background-color: #ff6811 !important;
}

.fixed-bottom-left-text:hover{
	color: #ff6811 !important;
}

.sidebar-dark {
  background-color: #424242 !important;
}

.sidebar-menu {
  background-color: #424242;
}

.menu-item {
  border-bottom: 1px solid #666 !important;
  border-radius: 5px !important;
  max-width: 90%;
  margin:  3px auto;
  transition: background-color 0.3s ease;
}



::-webkit-scrollbar-track {
	background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
	background: v-bind('dynamicColor');
	border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
	background: v-bind('dynamicColor');
	opacity: 0.8;
}

/* Estilos adicionais para garantir que a barra de rolagem do menu seja estilizada */
.v-navigation-drawer {
	--scrollbar-color: v-bind(dynamicColor);
}

.v-list {
	--scrollbar-color: v-bind(dynamicColor);
}

.fixed-bottom-left {
  position: fixed !important;
  bottom: 20px !important;
  left: 20px !important;
  z-index: 1000;
}

.fixed-bottom-left-text {
  position: fixed !important;
  bottom: 20px !important;
  left: 80px !important;
  z-index: 1000;
  color: #fda16bbe;
  font-size: 14px;
  font-weight: 500;
}



.search-container {
  background-color: #f5f5f5;
  padding: 16px;
  border-radius: 4px;
  margin: 0 auto;
}

.search-field ::v-deep .v-input__slot {
  border-radius: 4px;
  background-color: white;
}

/* Estilos para o header */
.sponsor-logo {
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 8px 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.sponsor-text {
  display: flex;
  align-items: center;
  gap: 8px;
}

.sponsor-main {
  font-weight: 600;
  color: #333;
  font-size: 14px;
}

.sponsor-separator {
  color: #F15A24;
  font-weight: bold;
  font-size: 16px;
}

.sponsor-sub {
  color: #F15A24;
  font-weight: 500;
  font-size: 12px;
}

.orange--text {
  color: #F15A24 !important;
}

.text-caption {
  font-size: 12px;
  color: #666;
}

.grey--text {
  color: #999 !important;
}

/* Estilos para o tema escuro */
.v-navigation-drawer--dark {
  background-color: #424242 !important;
}

.v-navigation-drawer--dark .v-list-item {
  color: white !important;
}

.v-navigation-drawer--dark .v-list-item:hover {
  background-color: #555 !important;
}

.v-navigation-drawer--dark .v-list-item--active {
  background-color: #666 !important;
}
</style>

<script>
	import '../assets/styles/scrollbar.css';
	import DialogFaq from '../components/DialogFaq.vue';
	import DialogIntegrantesGabinete from '../components/DialogIntegrantesGabinete.vue';
	export default {
		name: 'home',
		components: { DialogFaq, DialogIntegrantesGabinete },
		data() {
			return {
				showFaq: false,
				showDialogGabinete: false,
				drawer: true,
				listActive: 0,
				qtdeNotifications: 0,
				friendsWaitingAccept: [],
				groupsWaitingAccept: [],
				notificacoesVistas: false,
				items: [
					{ title: 'Feed', route: 'feed', icon: 'mdi-rss', color: '#a4a4a4' },
					{
						title: 'Legislações',
						route: 'legislacoes',
						icon: 'mdi-bookshelf',
						color: '#F15A24',
					},
					{
						title: 'Anotações',
						route: 'anotacoes',
						icon: 'mdi-pencil',
						color: '#a4a4a4',
					},
					// { title: "Favoritos", route: "favoritos", icon: "mdi-star" },
					{
						title: 'Grupos',
						route: 'grupos',
						icon: 'mdi-account-group',
						color: '#a4a4a4',
					},
					// { title: "Amigos", route: "amigos", icon: "mdi-account" },
					{
						title: 'Documentos',
						route: 'documentos',
						icon: 'mdi-file',
						color: '#a4a4a4',
					},
					{
						title: 'Perfil',
						route: 'perfil',
						icon: 'mdi-account-circle',
						color: '#F15A24',
					},
					{
						title: 'Lei',
						route: 'lei',
						icon: 'mdi-scale-balance',
						color: 'F15A24',
						hide: true,
					},
					{
						title: 'Projeto de Lei',
						route: 'projetoLei',
						icon: 'mdi-file-document',
						color: '#F15A24',
						hide: true,
					},
					{
						title: 'Grupo',
						route: 'gruposDetalhe',
						icon: 'mdi-account-group',
						color: '#F15A24',
						hide: true,
					},
					{
						title: 'Grupo - Arquivos',
						route: `grupoArquivos`,
						icon: 'mdi-folder',
						color: '#F15A24',
						hide: true,
					},
					{
						title: 'Vade-mécum',
						route: 'grupoVademecun',
						icon: 'mdi-bookshelf',
						color: '#F15A24',
						hide: true,
					},

					{
						title: 'Crawler',
						route: 'crawler',
						icon: 'mdi-account-group',
						color: '#a4a4a4',
						hide: true,
					},
					{
						title: 'Usuário',
						route: 'Perfil Usuário',
						icon: 'mdi-account-group',
						color: '#a4a4a4',
						hide: true,
					},
					// { title: "Teste Word", route: "ckeditor", icon: "mdi-file-word" },
				],
				banners: [],
				showBannerDestaque: 0,
			};
		},
		computed: {
			dynamicColor() {
				return this.$route.params.id_grupo === '6f5ff131-006f-4525-9b17-75ae9674a09f' ? '#d8934e' : '#F15A24';
			},
			label() {
				let rout = this.items.filter((e) => e.route === this.$route.name);
				return rout[0] || { title: 'Projeto de Lei', icon: 'mdi-file-document' };
			},
			/*************  ✨ Codeium Command ⭐  *************/
			/**
			 * Determines if the current route is the home feed.
			 * @returns {boolean} True if the current route is 'feed', otherwise false.
			 */
			/******  4f6abd82-b4c9-44f8-aedb-4c90a9243f9e  *******/
			isHome() {
				return this.$route.name == 'feed';
			},
			isPerfil() {
				return this.$route.name == 'perfil';
			},
			user() {
				return this.$store.state.user != undefined
					? this.$store.state.user
					: { first_name: 'Meu Perfil' };
			},
			intBreakPoint() {
				switch (this.$vuetify.breakpoint.name) {
					case 'xs':
						return 0;
					case 'sm':
						return 1;
					case 'md':
						return 2;
					case 'lg':
						return 3;
					case 'xl':
						return 4;
					default:
						return 0;
				}
			},
			itemsMenu() {
				return this.items.filter((e) => !e.hide);
			},
			pendingNotificationsCount() {
				return this.friendsWaitingAccept.length + this.groupsWaitingAccept.length;
			},
		},
		watch: {
			'$route.params.id_grupo': {
				immediate: true,
				handler(newVal) {
					if (newVal === '6f5ff131-006f-4525-9b17-75ae9674a09f') {
						document.body.setAttribute('data-grupo', newVal);
					} else {
						document.body.removeAttribute('data-grupo');
					}
				}
			},
			dynamicColor: {
				immediate: true,
				handler(newColor) {
					document.documentElement.style.setProperty('--scrollbar-color', newColor);
					// Forçar atualização do estilo no menu
					const menu = document.querySelector('.v-navigation-drawer');
					if (menu) {
						menu.style.setProperty('--scrollbar-color', newColor);
					}
				}
			}
		},
		async mounted() {
			// Buscar informações do usuário e aguardar para garantir que os grupos estão carregados
			await this.$store.dispatch('getInfo');
			
			// Aguardar um pouco para garantir que o relacionamento foi processado
			await new Promise(resolve => setTimeout(resolve, 300));

			// this.$store.dispatch("getUsuarios");
			this.reloadBanners();
			
			// Verificar e criar grupo do gabinete se necessário
			await this.verificarECriarGrupoGabinete();
			
			// Verificar se precisa mostrar dialog de gabinete
			this.verificarDialogGabinete();
			
			// Carregar notificações
			this.loadNotifications();
			
			// Listener para atualizar notificações quando ações são feitas
			this.$root.$on('atualizar-notificacoes', () => {
				this.loadNotifications();
				// Se houver novas notificações após uma ação, marcar como não vistas
				this.$nextTick(() => {
					if (this.friendsWaitingAccept.length > 0 || this.groupsWaitingAccept.length > 0) {
						this.notificacoesVistas = false;
					}
				});
			});
			
			// Listener para quando o diálogo de amigos é fechado
			this.$root.$on('dialog-amigos-fechado', () => {
				// Verificar se ainda há notificações pendentes
				this.$nextTick(() => {
					if (this.friendsWaitingAccept.length === 0 && this.groupsWaitingAccept.length === 0) {
						this.notificacoesVistas = false;
					}
				});
			});
			
			// Listener para quando as notificações são vistas (diálogo aberto)
			this.$root.$on('notificacoes-vistas', () => {
				this.notificacoesVistas = true;
			});
			
			// Configurar intervalo para atualizar notificações a cada 30 segundos
			this.notificationsInterval = setInterval(() => {
				this.loadNotifications();
				// Se houver novas notificações, marcar como não vistas
				this.$nextTick(() => {
					if (this.friendsWaitingAccept.length > 0 || this.groupsWaitingAccept.length > 0) {
						// Só marcar como não vistas se já foram vistas antes
						// Isso evita mostrar badge imediatamente ao carregar a página
						if (this.notificacoesVistas) {
							this.notificacoesVistas = false;
						}
					}
				});
			}, 30000);
			
			// Configurar o atributo data-grupo inicial
			if (this.$route.params.id_grupo === '6f5ff131-006f-4525-9b17-75ae9674a09f') {
				document.body.setAttribute('data-grupo', this.$route.params.id_grupo);
			}
			
			// Configurar a cor inicial
			const color = this.dynamicColor;
			document.documentElement.style.setProperty('--scrollbar-color', color);
			
			// Forçar atualização do estilo no menu
			this.$nextTick(() => {
				const menu = document.querySelector('.v-navigation-drawer');
				if (menu) {
					menu.style.setProperty('--scrollbar-color', color);
				}
			});
		},
		beforeDestroy() {
			this.$root.$off('atualizar-notificacoes');
			this.$root.$off('dialog-amigos-fechado');
			this.$root.$off('notificacoes-vistas');
			if (this.notificationsInterval) {
				clearInterval(this.notificationsInterval);
			}
			document.body.removeAttribute('data-grupo');
			document.documentElement.style.removeProperty('--scrollbar-color');
			const menu = document.querySelector('.v-navigation-drawer');
			if (menu) {
				menu.style.removeProperty('--scrollbar-color');
			}
		},
		methods: {
			async loadNotifications() {
				try {
					// Carregar convites de amizade pendentes
					const friendsData = await this.$http.get(
						`items/add_amigo/?fields=id,id_usuario.id,id_usuario.first_name,id_usuario.avatar,id_usuario.last_name&filter[status][_eq]=pendente&filter[id_adicionado][_eq]=${this.$store.state.user.id}`
					);
					this.friendsWaitingAccept = friendsData.data.data || [];
					
					// Carregar convites de grupos pendentes
					const groupsData = await this.$http.get(
						`items/add_grupos/?fields=id,id_grupo.id,id_grupo.nome_grupo&filter[status][_eq]=pendente&filter[id_usuario][_eq]=${this.$store.state.user.id}`
					);
					this.groupsWaitingAccept = groupsData.data.data || [];
				} catch (error) {
					window.console.error('Erro ao carregar notificações:', error);
				}
			},
			abrirAmigos() {
				// Marcar notificações como vistas ao abrir o diálogo
				this.notificacoesVistas = true;
				
				// Se estiver na página do feed, emitir evento para abrir o diálogo
				if (this.$route.name === 'feed') {
					this.$root.$emit('abrir-dialog-amigos');
				} else {
					// Caso contrário, navegar para o feed
					this.$router.push({ name: 'feed' }).then(() => {
						// Aguardar um pouco para garantir que o componente foi montado
						this.$nextTick(() => {
							setTimeout(() => {
								this.$root.$emit('abrir-dialog-amigos');
							}, 300);
						});
					});
				}
			},
			async verificarECriarGrupoGabinete() {
				const user = this.$store.state.user;
				
				if (!user || !user.id) return;
				
				// Verificar se o usuário tem plano legislativo
				const planoLegislativo = user && user.plano && (
					user.plano === 'plano-legislativo' ||
					user.plano === 'plano_legislativo' ||
					user.plano === 'legislativo' ||
					user.plano.toLowerCase().includes('legislativo') ||
					user.plano === 'plan_g3180ooh6OSo0Wzx'
				);
				
				if (!planoLegislativo) return;
				
				// PRIMEIRA VERIFICAÇÃO: Se o usuário tem o campo eh_convidado_gabinete = true, ele é convidado
				// Isso é mais confiável que verificar grupos, pois é definido no momento do cadastro
				if (user.eh_convidado_gabinete === true || user.admin_gabinete_id) {
					return;
				}
				
				// SEGUNDA VERIFICAÇÃO: Verificar se o usuário é convidado através dos grupos que ele tem acesso
				// Se ele tem grupos do gabinete onde NÃO é o criador, então é convidado
				if (user.grupos && user.grupos.length > 0) {
					const gruposGabinete = user.grupos.filter(g => 
						g.grupos_id && 
						g.grupos_id.nome_grupo && 
						g.grupos_id.nome_grupo.includes('Gabinete') &&
						g.grupos_id.user_created !== user.id // Não é criador
					);
					
					if (gruposGabinete.length > 0) {
						return;
					}
				}
				
				try {
					// Verificar se o usuário é criador de algum grupo do gabinete (é admin)
					const { data } = await this.$http.get(
						`items/grupos?filter[user_created][_eq]=${user.id}&filter[restrito][_eq]=true&filter[nome_grupo][_contains]=Gabinete&fields=id`
					);
					
					// Se o usuário não criou nenhum grupo, verificar se é convidado
					if (!data.data || data.data.length === 0) {
						// PRIMEIRO: Verificar se o usuário tem grupos no store (mais rápido)
						if (user.grupos && user.grupos.length > 0) {
							const gruposGabineteNoStore = user.grupos.filter(g => 
								g.grupos_id && 
								g.grupos_id.nome_grupo && 
								g.grupos_id.nome_grupo.includes('Gabinete') &&
								g.grupos_id.user_created !== user.id
							);
							
							if (gruposGabineteNoStore.length > 0) {
								return;
							}
						}
						
						// SEGUNDO: Buscar diretamente os grupos onde o usuário é integrante (mais confiável)
						// Verificar se ele é integrante de algum grupo (convidado)
						try {
							// Buscar grupos onde o usuário é integrante usando a tabela de relacionamento
							// Primeiro, buscar todos os grupos do gabinete
							const { data: todosGruposGabinete } = await this.$http.get(
								`items/grupos?filter[restrito][_eq]=true&filter[nome_grupo][_contains]=Gabinete&fields=id,user_created,integrantes.directus_users_id.id`
							);
							
							// Filtrar no cliente os grupos onde o usuário é integrante (mas não é criador)
							const gruposComoIntegrante = todosGruposGabinete.data.filter(grupo => {
								// Verificar se o usuário NÃO é o criador do grupo
								if (grupo.user_created === user.id) {
									return false;
								}
								
								// Verificar se o usuário é integrante
								const isIntegrante = grupo.integrantes && grupo.integrantes.some(integrante => 
									integrante.directus_users_id && integrante.directus_users_id.id === user.id
								);
								
								return isIntegrante;
							});
							
							// Se ele é integrante de algum grupo (mas não é criador), não criar grupo próprio (é convidado)
							if (gruposComoIntegrante.length > 0) {
								return;
							}
						} catch (err) {
							window.console.error('Erro ao verificar grupos como integrante:', err);
							// Em caso de erro, por segurança, não criar grupo para evitar duplicação
							return;
						}
						
						// Se não criou e não é integrante, então é admin e deve criar o grupo
						const { data: newGroupData } = await this.$http.post('items/grupos', {
							nome_grupo: `Gabinete de ${user.first_name}`,
							restrito: true,
							tipo_grupo: 'gabinete',
							status: 'published',
							user_created: user.id,
							administradores: [{
								directus_users_id: user.id
							}],
							integrantes: [{
								directus_users_id: user.id
							}]
						});
						
					}

					// Em ambos os casos acima (gabinete criado agora ou já existente),
					// garantir que o grupo de Eleitores também exista para este admin.
					try {
						// Atenção: o Directus não permite filtrar por "tipo_grupo" nesta coleção,
						// então usamos o nome do grupo como identificador padrão.
						const { data: existingEleitores } = await this.$http.get(
							`items/grupos?filter[user_created][_eq]=${user.id}&filter[nome_grupo][_contains]=Eleitores&fields=id`
						);

						if (!existingEleitores.data || existingEleitores.data.length === 0) {
							const { data: newEleitoresGroup } = await this.$http.post('items/grupos', {
								nome_grupo: `Eleitores de ${user.first_name}`,
								// Grupo de Eleitores deve ser público, portanto não restrito
								restrito: false,
								// Mantemos o tipo_grupo na criação apenas para uso interno/relatórios,
								// mas NÃO o usamos em filtros para evitar erro 400.
								tipo_grupo: 'eleitores',
								status: 'published',
								user_created: user.id,
								administradores: [{
									directus_users_id: user.id
								}],
								integrantes: [{
									directus_users_id: user.id
								}]
							});

						}
					} catch (erroEleitores) {
						window.console.error('Erro ao verificar/criar grupo de Eleitores:', erroEleitores);
					}
				} catch (error) {
					window.console.error('Erro ao verificar/criar grupo do gabinete:', error);
				}
			},
			async verificarDialogGabinete() {
				const user = this.$store.state.user;
				
				// Verificar se o usuário tem plano legislativo (aceitar variações do nome)
				const planoLegislativo = user && user.plano && (
					user.plano === 'plano-legislativo' ||
					user.plano === 'plano_legislativo' ||
					user.plano === 'legislativo' ||
					user.plano.toLowerCase().includes('legislativo') ||
					user.plano === 'plan_g3180ooh6OSo0Wzx' // ID do Pagar.me
				);
				
				if (!planoLegislativo || !user) {
					return;
				}
				
				// IMPORTANTE: Verificar se o usuário é ADMIN (criador do grupo), não apenas integrante
				// A dialog só deve aparecer para admins do plano legislativo
				try {
					const { data } = await this.$http.get(
						`items/grupos?filter[user_created][_eq]=${user.id}&filter[restrito][_eq]=true&filter[nome_grupo][_contains]=Gabinete&fields=id,integrantes.directus_users_id.id`
					);
					
					// Se o usuário não criou nenhum grupo, ele é convidado e NÃO deve ver o dialog
					const isAdmin = data.data && data.data.length > 0;
					
					if (!isAdmin) {
						return;
					}
					
					// Verificar se o gabinete possui integrantes além do admin
					const grupoGabinete = data.data[0];
					const integrantes = (grupoGabinete && grupoGabinete.integrantes) ? grupoGabinete.integrantes : [];
					const quantidadeIntegrantes = integrantes.length;
					
					// Se tiver apenas o admin (1 integrante), exibir a dialog
					// Se tiver mais de 1 integrante (admin + outros), não exibir a dialog
					const temApenasAdmin = quantidadeIntegrantes <= 1;
					
					if (temApenasAdmin) {
						this.showDialogGabinete = true;
					}
				} catch (error) {
					window.console.error('Erro ao verificar se é admin do grupo:', error);
					// Em caso de erro, não exibir o dialog por segurança
				}
			},
			handleRatingSubmitted(ratingData) {
				window.console.log('Feedback CSAT enviado:', ratingData);
				// Opcional: mostrar uma mensagem de agradecimento
			},
			async reloadBanners() {
				const { data } = await this.$http.get(
					`/items/banners/?fields=*,banners.*&filter[local][_eq]=painel`
				);
				this.banners = data.data[0] ? data.data[0].banners : [];
			},
			logout() {
				this.$store.dispatch('logout').then(() => {
					this.$router.push('/');
				});
			},
			openPerfil() {
				this.$router.push('/home/perfil');
			},
			openWhats() { 
				window.open("https://wa.me/5521991644663?text=Olá", "_blank")
			},
			sanitizeTitle(title) {
				var slug = '';
				// Change to lower case
				var titleLower = title.toLowerCase();
				// Letter "e"
				slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e');
				// Letter "a"
				slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a');
				// Letter "o"
				slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o');
				// Letter "u"
				slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u');
				// Letter "d"
				slug = slug.replace(/đ/gi, 'd');
				// Trim the last whitespace
				slug = slug.replace(/\s*$/g, '');
				// Change whitespace to "-"
				slug = slug.replace(/\s+/g, '-');

				return slug;
			},
		},
	};
</script>
